import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import useTranslation from 'next-translate/useTranslation'
import styles from './styles.module.scss'

interface IProps {
  handleVisibleChange: any
  isVisible: boolean
  children?: React.ReactNode
  className?: string
}

const CompanyFilters = ({
  handleVisibleChange,
  isVisible,
  children,
  className,
}: IProps) => {
  const { t } = useTranslation('common')

  return (
    <div
      className={`md:container md:mt-6 pb-6 z-10  ${styles.filters__wrapper} ${
        isVisible ? styles['filters--visible'] : styles['filters--rwd-hidden']
      } ${className}`}
    >
      <div
        className={`${styles['filters__close-wrapper']} ${
          isVisible ? styles.isVisible : styles.isHidden
        }`}
      >
        <button
          className={styles.filters__close}
          onClick={handleVisibleChange}
          type='button'
          title={t('close')}
        >
          <XMarkIcon width={24} className='max-w-2xl' />
        </button>
      </div>
      {children}
    </div>
  )
}

export default CompanyFilters
